import { useSelector } from "react-redux";
import { useMemo } from "react";
import { VIP_STATUS } from "helpers/constants";

export const useMemoizedUser = () => {
	const id = useSelector((state) => state.userProfileMain?.id);
	const user_id = useSelector((state) => state.userProfileMain?.user_id);
	const login = useSelector((state) => state.userProfileMain?.login);
	const avatar = useSelector((state) => state.userProfileMain?.avatar);
	const online = useSelector((state) => state.userProfileMain?.online);
	const status_vip = useSelector(
		(state) => state.userProfileMain?.status_vip
	);
	const vip = useSelector((state) => state.userProfileMain?.vip);
	const private_data = useSelector(
		(state) => state.userProfileMain?.private_data
	);
	const profile_status = useSelector(
		(state) => state.userProfileMain?.profile_status
	);
	const showStatusVip = useSelector(
		(state) => state.userProfileMain?.showStatusVip
	);
	const privateData = useSelector(
		(state) => state.userProfileMain?.privateData
	);
	const profileStatus = useSelector(
		(state) => state.userProfileMain?.profileStatus
	);
	const frozen = useSelector((state) => state.userProfileMain?.frozen);
	// references array and objects
	const searchSexArray = useSelector(
		(state) => state.userProfileMain?.search?.search_sex
	);
	const searchAgeObject = useSelector(
		(state) => state.userProfileMain?.search?.search_age
	);
	const searchForArray = useSelector(
		(state) => state.userProfileMain?.search?.search_for
	);
	const preferencesArray = useSelector(
		(state) => state.userProfileMain?.preferences
	);
	const interestArray = useSelector(
		(state) => state.userProfileMain?.preferences
	);
	const descriptionObject = useSelector(
		(state) => state.userProfileMain?.description
	);
	const listOfLinksArray = useSelector(
		(state) => state.userProfileMain?.listOfLinks
	);
	/////////////////////////////////
	const currentLoggedUserId = useSelector((state) => state.global.user?.id);
	const currentLoggedUserStatusVip = useSelector(
		(state) => state.global.user?.status_vip
	);
	const currentLoggedUserShowStatusVip = useSelector(
		(state) => state.global.user?.showStatusVip
	);

	const isMe = id === currentLoggedUserId || user_id === currentLoggedUserId;
	const statusVip = () => {
		if (isMe) {
			if (currentLoggedUserShowStatusVip === false) {
				if (currentLoggedUserStatusVip > VIP_STATUS.VERIFIED) {
					return VIP_STATUS.VERIFIED;
				}
				return currentLoggedUserStatusVip;
			}
			return currentLoggedUserStatusVip;
		}
		return vip;
	};
	/////////////////////////////////

	const memoizedUser = useMemo(
		() => ({
			id,
			user_id,
			login,
			avatar,
			online,
			status_vip: statusVip(),
			private_data,
			profile_status,
			showStatusVip,
			privateData,
			profileStatus,
			frozen,
			// references array and objects - NO IN DEPENDENCY ARRAY!
			searchSexArray,
			searchAgeObject,
			searchForArray,
			preferencesArray,
			interestArray,
			descriptionObject,
			listOfLinksArray,
		}),
		[
			id,
			user_id,
			login,
			avatar,
			online,
			status_vip,
			private_data,
			profile_status,
			showStatusVip,
			privateData,
			profileStatus,
			frozen,
		]
	);

	// const userAll = useSelector((state) => state.user.main);
	// console.log("userAll", userAll);
	// console.log("memoizedUser", memoizedUser);
	return memoizedUser;
};
